import config from '@/models/services/config';
import * as CA from '@/models/services/courseatlas/entities';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import jsonpAdapter from 'axios-jsonp';

type transform = (search: string) => string;

interface IAxiosJsonpConfig extends AxiosRequestConfig {
	callbackParamName: string;
}

export default class Client {
	public async courseSearch(params: CA.ICourseSearchParameters): Promise<CA.ICourse[]> {
		const request = this.buildRequest(`Institutions(${params.institutionId})/Courses`, params, (search) =>
			`startswith(FullTitle, '${search}')`,
			(filter) => `&$orderby=FullTitle`);

		return await axios<never, { value: CA.ICourse[] }>(request).then((resp) => {
			return resp.data.value;
		});
	}

	public async institutionSearch(params: CA.IOdataSearchParameters): Promise<CA.IInstitution[]> {
		const request = this.buildRequest('Institutions', params,
			(search) => `startswith(Name, '${search}')`,
			(filter) => `&$orderby=Name`);

		return await axios<never, { value: CA.IInstitution[] }>(request).then((resp) => {
			return resp.data.value;
		});
	}

	private buildRequest(endPoint: string, params: CA.IOdataSearchParameters, filter: transform, order: transform)
		: AxiosRequestConfig {
		return {
			url: this.buildRequestUrl(endPoint, params, filter, order),
			adapter: jsonpAdapter,
			callbackParamName: '$callback', // optional, 'callback' by default
		} as IAxiosJsonpConfig;
	}

	private buildRequestUrl(endPoint: string, params: CA.IOdataSearchParameters, filter: transform, order: transform) {
		const search = params.search && params.search.replace('\'', '\'\'');
		let url = config.CourseAtlasUrl + endPoint + '?$format=json';
		if (search) {
			url = url + '&$filter=' + filter(search);
		}
		return url + order(url)
			+ `&$top=${params.top || 10}`
			+ `&$skip=${params.skip || 0}`;
	}
}
